var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useMemo, useState } from "react";
import { Flex, Text, Anchor, Icon } from "@costar/theme-ui";
import { lineStyles, lineStylesListView, footerStyles, footerStylesListView } from "./constants";
import { TermsOfUse } from "../modals";
var Footer = function (_a) {
    var termsOfUseUrl = _a.termsOfUseUrl, noLogo = _a.noLogo, messages = _a.messages;
    var _b = useState({ termsOfUseShown: false }), state = _b[0], setState = _b[1];
    var showHideTermsOfUse = useCallback(function (show) {
        setState({
            termsOfUseShown: show,
        });
    }, []);
    var onAccept = useCallback(function () { return showHideTermsOfUse(false); }, [showHideTermsOfUse]);
    var onCloseOrDecline = useCallback(function () { return showHideTermsOfUse(false); }, [showHideTermsOfUse]);
    var termsOfUse = useCallback(function (e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        showHideTermsOfUse(true);
    }, [showHideTermsOfUse]);
    var footerLineStyles = useMemo(function () {
        return noLogo ? lineStylesListView : lineStyles;
    }, [noLogo]);
    var footerFlexStyles = useMemo(function () {
        return noLogo ? footerStylesListView : footerStyles;
    }, [noLogo]);
    return (React.createElement(Flex, __assign({}, footerFlexStyles, { flexDirection: "column", alignItems: noLogo ? "flex-start" : "center", "automation-id": "footer", className: "searchx-footer" }),
        !noLogo && (React.createElement(Flex, { justifyContent: "center", width: "100%", pt: "5px", pb: "6px", my: 0, mx: "auto", "automation-id": "footer-logo" },
            React.createElement(Icon, { icon: "costarLogo", width: 99, height: 27 }))),
        React.createElement(Text, __assign({}, footerLineStyles), messages.copyrightLine1),
        React.createElement(Text, __assign({}, footerLineStyles),
            messages.copyrightLine2,
            React.createElement(Anchor, { color: "primary", onClick: termsOfUse, "automation-id": "footer-terms-of-use-open-fodal" }, messages.termsOfUse)),
        state.termsOfUseShown && (React.createElement(TermsOfUse, { acceptDeclineMode: false, onAccept: onAccept, onCloseOrDecline: onCloseOrDecline, termsOfUseUrl: termsOfUseUrl, messages: messages }))));
};
export { Footer };
//# sourceMappingURL=Footer.js.map